export class StepProgressSnapshotEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "unit",
            "baseName": "unit",
            "type": "string",
            "format": ""
        },
        {
            "name": "done",
            "baseName": "done",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "total",
            "baseName": "total",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return StepProgressSnapshotEntry.attributeTypeMap;
    }
    constructor() {
    }
}
